import React from 'react';
import {object, func, bool} from 'prop-types';
import moment from 'moment';

import { get } from 'lodash';

import EsmsModal from '../../components/EsmsModal';

import classes from './RuleInformationModal.module.css';
import { getTimeZoneAbbr } from '../../helpers/timezones';

const RuleInformationModal = ({
    onClose,
    open,
    rule
}) =>  {

    const statusFormatter = () => {
        switch (rule.status) {
            case true:
                return 'Fault';
            case false:
                return 'Ok';
            default:
                return null;
        }
    };

    const getDescription = item => {
        const description = get(item, 'description', null);

        if (description) {
            return (
                <React.Fragment>
                    <dt>Description</dt>
                    <dd>{description}</dd>
                </React.Fragment>
            );
        }

        return null;
    };

    const getIssueTypes = item => {
        const issueTypes = get(item, 'issueTypes', []);

        if (issueTypes.length === 1) {
            return (
                <React.Fragment>
                    <dt>Issue Type</dt>
                    <dd>{issueTypes[0]}</dd>
                </React.Fragment>
            );
        } else if (issueTypes.length > 1) {
            return (
                <React.Fragment>
                    <dt>Issue Types</dt>
                    <dd>{issueTypes.join(', ')}</dd>
                </React.Fragment>
            );
        }

        return null;
    };

    const ruleFormatter = item => {
        const timestamp = get(item, 'timestamp', null);
        if (timestamp) {
            const zone = moment.tz.guess();
            return moment.parseZone(timestamp).local().format('YYYY-MM-DD h:mm A') + ' ' + getTimeZoneAbbr(timestamp, zone);
        }
        return timestamp;
    };

    return (
        <EsmsModal
            classes={classes}
            open={open}
            onClose={onClose}
            title="Rule Information"
        >
            <dl className={classes.RuleInformationModal}>
                <dt>Rule</dt>
                <dd>{rule.name}</dd>

                {getDescription(rule)}

                {getIssueTypes(rule)}

                <dt>Target</dt>
                <dd>{rule.snapshotRoute}</dd>

                <dt>Status</dt>
                <dd>{statusFormatter()}</dd>

                <dt>Last Successful Execution</dt>
                <dd>{ruleFormatter(rule)}</dd>

                <dt>System Effect</dt>
                <dd>{rule.systemEffect}</dd>

                <dt>Recommendation</dt>
                <dd>{rule.recommendation}</dd>
            </dl>
        </EsmsModal>
    );
};

RuleInformationModal.defaultProps = {
    onClose: () => {},
    open:    false,
    rule:    {}
};

RuleInformationModal.propTypes = {
    onClose: func.isRequired,
    open:    bool.isRequired,
    rule:    object.isRequired
};

export default RuleInformationModal;
